<div class="flex flex-col">
  <div class="flex flex-col my-4">
    <span class="text-xl font-bold">2. Selecciona un servicio</span>
    <span class="text-md my-3">
      Seleccionar el servicio para el cual necesites consultar los datos de {{ nameProtocol }}.
    </span>
    <app-search-bar
      [showExternalButton]="true"
      [placeholder]="'Buscar por nombre de procedimiento, organismo, código de procedimiento o código de organismo'"
      (search)="handleSearch($event)" />
  </div>
  <div class="my-4 font-bold flex justify-between items-center">
    <span>{{ totalResults() }} servicios</span>
  </div>
  <div>
    @for (item of services(); track item.id) {
      <app-description-card
        [subtitle]="`${item.organismCode} - ${item.organismName}`"
        [title]="`${item.id} - ${item.procedureName}`"
        [urlDetail]="urlDetail()"
        [actions]="item.actions" />
    }
  </div>
  <app-pagination
    [totalItems]="totalResults()"
    [paginationSize]="paginationSize()"
    [currentPage]="currentPage()"
    (paginationSizeChange)="paginationSize.set($event)"
    (currentPageChange)="currentPage.set($event)" />
</div>
